import header from '../modules/header/index';
import checkout from '../modules/checkoutModule';
import filteredProducts from "../modules/filter/filteredProducts";
import initCustomForms from '../modules/initCustomForms';
import initPopups from '../modules/initPopups';
import scrollHidden from '../modules/scrollHidden';
import addToCardEventInit from "../modules/addToCardEvent";

jQuery(function() {
    header();
    checkout();
    initCustomForms();
    initPopups();
    scrollHidden();

    const $dataContainer = $('.data-container');
    const title = $dataContainer.attr('data-title');
    const metaDescription = $dataContainer.attr('data-meta-description'); 

    filteredProducts({
        showCatalog: true,
        showCategory: true,
        showGroup: true,
        showBrand: true,
        defaultSortBy: 'score',
        updateCatalogFilter: true,
        updateBrandFilter: true,
        apiUrl: '/umbraco/api/products/GetPaginatedSearch',
        title,
        metaDescription
    });
    addToCardEventInit();
})